module.exports = __webpack_public_path__ + "static/olabisi-54a1e22bbad8f1c89f68702bdc837c14.png";